import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
    Box,
    Container,
    Paper,
    Typography,
    CircularProgress,
    Alert,
    Button,
} from '@mui/material';
import axios from 'axios';
import { internshipDomain, phonepeDomain } from '../util/domain';

const Status = () => {
    const { merchantTransactionId } = useParams();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const [status, setStatus] = useState('PENDING');
    const [registration_hash_id, setRegistrationHashId] = useState('');

    useEffect(() => {
        checkPaymentStatus();
    }, [merchantTransactionId]);

    const checkPaymentStatus = async () => {
        try {
            const response = await axios.get(`${phonepeDomain}/api/payment/status/${merchantTransactionId}`);// passing merchantTransactionId

            console.log("response :", response);
            // {
            //     success: true,
            //     payment,
            //     phonepeStatus: verificationResponse.data
            // }
            if (response.data.success) {
                const paymentDetails = response.data.payment;
                const phonepeStatus = response.data.phonepeStatus;
                setStatus(response.data.phonepeStatus);
                const userRegistrationId = paymentDetails.registration_hash_id;

                if (phonepeStatus === "SUCCESS") {
                    // Redirect to event pass after 2 seconds
                    setTimeout(() => {
                        navigate(`/event-pass/${userRegistrationId}`);
                    }, 1000);
                } else if (phonepeStatus === 'FAILED') {
                    setRegistrationHashId(response.data.payment.registration_hash_id);
                    setError('Payment failed. Please try again.');
                } else if (phonepeStatus === 'PENDING') {
                    // Check again after 5 seconds
                    setTimeout(checkPaymentStatus, 5000);
                }
            } else if (response.data.phonepeStatus === 'FAILED') {
                console.log("payment failed :", JSON.stringify(response.data));
                setRegistrationHashId(response.data.payment.registration_hash_id);
                setError('Payment failed. Please try again.');
            } else {
                throw new Error('Failed to verify payment');
            }
        } catch (error) {
            setError(error.response?.data?.message || 'Failed to verify payment status');
        } finally {
            setLoading(false);
        }
    };

    const handleRetryPayment = () => {
        if (registration_hash_id && registration_hash_id !== '') {
            window.location.href = `${phonepeDomain}/payment/${registration_hash_id}`;
        } else {
            setError('Please contact support');
        }
    };

    return (
        <Container maxWidth="sm">
            <Paper elevation={3} sx={{ p: 4, mt: 4 }}>
                <Typography variant="h4" component="h1" gutterBottom align="center">
                    Payment Status
                </Typography>

                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                    {loading ? (
                        <>
                            <CircularProgress />
                            <Typography>
                                Verifying payment status...
                            </Typography>
                        </>
                    ) : status === 'SUCCESS' ? (
                        <Alert severity="success" sx={{ width: '100%' }}>
                            Payment successful! Redirecting to event pass...
                        </Alert>
                    ) : status === 'FAILED' ? (
                        <>
                            <Alert severity="error" sx={{ width: '100%' }}>
                                {error}
                            </Alert>
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleRetryPayment}
                                sx={{ mt: 2 }}
                            >
                                Retry Payment
                            </Button>
                        </>
                    ) : (
                        <>
                            <CircularProgress />
                            <Typography>
                                Payment verification in progress...
                            </Typography>
                        </>
                    )}
                </Box>
            </Paper>
        </Container>
    );
};

export default Status;
